import { Locale } from "../Locale.js";
import type { LocalizedString } from "../Locale.js";
import { PaymentType } from "../PaymentType.js";

export const paymentTypeNameMap: Record<PaymentType, LocalizedString> = {
	[PaymentType.GoPayPaymentCard]: { [Locale.cs]: "Kartou" },
	[PaymentType.GoPayGPay]: { [Locale.cs]: "Google Pay" },
	[PaymentType.GoPayApplePay]: { [Locale.cs]: "Apple Pay" },
};

export const paymentTypeLongNameMap: Record<PaymentType, LocalizedString> = {
	[PaymentType.GoPayPaymentCard]: { [Locale.cs]: "Platební kartou" },
	[PaymentType.GoPayGPay]: { [Locale.cs]: "Google Pay" },
	[PaymentType.GoPayApplePay]: { [Locale.cs]: "Apple Pay" },
};
